import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FaAppStoreIos, FaGooglePlay } from 'react-icons/fa';
import { MOBILE_APP_STORE_URLS } from './mobileAppLinks';

interface StoreBadgeProps {
  href: string;
  icon: React.ReactNode;
  iconBg: string;
  iconColor: string;
  topLabel: string;
  bottomLabel: string;
  ariaLabel: string;
}

const StoreBadgeRoot = styled('a')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '11px 18px',
  borderRadius: '10px',
  border: '1px solid #e0e6ec',
  backgroundColor: '#fff',
  textDecoration: 'none',
  minWidth: 230,
  transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
  '&:hover': {
    borderColor: '#c8d0f8',
    boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
  },
});

const StoreBadgeIconBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'iconBg' && prop !== 'iconColor',
})<{ iconBg: string; iconColor: string }>(({ iconBg, iconColor }) => ({
  width: 40,
  height: 40,
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  fontSize: '1.6rem',
  backgroundColor: iconBg,
  color: iconColor,
}));

const StoreBadge = ({ href, icon, iconBg, iconColor, topLabel, bottomLabel, ariaLabel }: StoreBadgeProps) => (
  <StoreBadgeRoot href={href} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel}>
    <StoreBadgeIconBox iconBg={iconBg} iconColor={iconColor} aria-hidden="true">
      {icon}
    </StoreBadgeIconBox>
    <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
      <Typography component="span" sx={{ fontSize: '0.75rem', color: '#66727e' }}>
        {topLabel}
      </Typography>
      <Typography component="span" sx={{ fontSize: '1.0714rem', fontWeight: 700, color: '#1a2636' }}>
        {bottomLabel}
      </Typography>
    </Box>
  </StoreBadgeRoot>
);

const MobileAppStoreBadges = () => (
  <Stack direction="column" spacing={1.25} sx={{ flexShrink: 0 }}>
    <StoreBadge
      href={MOBILE_APP_STORE_URLS.IOS}
      icon={<FaAppStoreIos />}
      iconBg="#e3f2fd"
      iconColor="#0D96F6"
      topLabel="Download on the"
      bottomLabel="App Store"
      ariaLabel="Download SecurSpace Gate Check on the Apple App Store"
    />
    <StoreBadge
      href={MOBILE_APP_STORE_URLS.ANDROID}
      icon={<FaGooglePlay />}
      iconBg="#e6f4ea"
      iconColor="#01875F"
      topLabel="Get it on"
      bottomLabel="Google Play"
      ariaLabel="Get SecurSpace Gate Check on Google Play"
    />
  </Stack>
);

export default MobileAppStoreBadges;
